import React, { useCallback } from 'react';
import { Box, Grid, makeStyles, Typography } from 'housecall-ui';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';

import { Cart } from '../components/Cart/Cart';
import { Layout } from '../components/Layout';
import { QuantityInput } from '../components/QuantityInput';
import { ScrollableContent } from '../components/ScrollableContent';
import { StepProgressBar } from '../components/StepProgressBar';
import { useChangeStep } from '../hooks/useChangeStep';
import { useOnlineBookingReducer } from '../state/useOnlineBookingReducer';
import { formatMoney } from '../utils/formatMoney';

import { BackArrowButton } from './BackArrowButton';

const useStyles = makeStyles(() => ({
  imageClass: {
    display: 'block',
    maxHeight: '170px',
    maxWidth: '100%',
    borderRadius: '3px',
  },
  descriptionClass: {
    whiteSpace: 'pre-wrap',
  },
}));

const MAX_VALUE = 10000;

export const ServiceDetailsStep = () => {
  const { imageClass, descriptionClass } = useStyles();
  const {
    dispatch,
    actions,
    state: { service, draftQuantity },
  } = useOnlineBookingReducer();
  const { changeStep } = useChangeStep();

  const onQuantityChange = useCallback(
    (value: number) => dispatch(actions.setDraftQuantity(value)),
    [actions, dispatch]
  );

  const handleNext = () => {
    dispatch(actions.addToCart());
    changeStep('services-troubleshooting');
  };

  const handleBackClick = () => {
    changeStep('services');
  };

  return (
    <Layout
      ContentComponent={
        <>
          <BackArrowButton onClick={handleBackClick} />
          <ScrollableContent>
            <Box my={1}>
              <Grid container wrap="wrap" direction="column" spacing={2}>
                {service?.image ? (
                  <Grid item>
                    <img alt="service" src={service?.image} className={imageClass} />
                  </Grid>
                ) : null}
                <Grid item xs={12}>
                  <Typography variant="h3">{service?.name}</Typography>
                </Grid>
                <Box ml={1} display="flex" justifyContent="flex-start" alignItems="center">
                  <Box mr={1}>
                    <QuantityInput maxValue={MAX_VALUE} onChange={onQuantityChange} />
                  </Box>
                  {service?.price ? (
                    <Typography variant="subtitle2" data-testid="service-price">
                      {formatMoney(service.price * draftQuantity)}
                    </Typography>
                  ) : null}
                </Box>
                {service?.description ? (
                  <Grid item>
                    <Typography variant="body2" color="secondary" className={descriptionClass}>
                      {service?.description}
                    </Typography>
                  </Grid>
                ) : null}
              </Grid>
            </Box>
          </ScrollableContent>
        </>
      }
      Buttons={
        <Button version="v2" size="medium" fullWidth variant="contained" color="secondary" onClick={handleNext}>
          Add to Booking
        </Button>
      }
      Header={
        <>
          <StepProgressBar currentStep={1} stepCount={5} />
          <Cart />
        </>
      }
    />
  );
};
